var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_718:24385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4583 6.125H13.9583V6.625V7.60417V8.08333V8.10417V8.58333V9.5625V10.0417V10.0625V10.5417V11.5208V12.0208H14.4583H21.3125H21.8125V11.5208V10.5417V10.0625H22.2917H22.7917V9.5625V8.58333V8.10417V8.08333V7.60417V6.625V6.125H22.2917H14.4583ZM2.20833 18.375V18.875H2.70833H14.4583H14.9583V18.375V17.3958C14.9583 16.7243 14.6192 16.1677 14.159 15.7333C13.7012 15.3013 13.0906 14.9559 12.448 14.6873C11.1647 14.1509 9.63048 13.8702 8.58333 13.8702C7.53618 13.8702 6.002 14.1509 4.71863 14.6873C4.07602 14.9559 3.46544 15.3013 3.00771 15.7333C2.54742 16.1677 2.20833 16.7243 2.20833 17.3958V18.375ZM2.70833 4.1875H22.2917C23.0436 4.1875 23.75 4.89385 23.75 5.64583V19.3542C23.75 20.1061 23.0436 20.8125 22.2917 20.8125H2.70833C1.95635 20.8125 1.25 20.1061 1.25 19.3542V5.64583C1.25 4.89385 1.95635 4.1875 2.70833 4.1875ZM8.58333 6.125C7.67165 6.125 6.79731 6.48716 6.15265 7.13182C5.508 7.77648 5.14583 8.65082 5.14583 9.5625C5.14583 10.4742 5.508 11.3485 6.15265 11.9932C6.79731 12.6378 7.67165 13 8.58333 13C9.49502 13 10.3694 12.6378 11.014 11.9932C11.6587 11.3485 12.0208 10.4742 12.0208 9.5625C12.0208 8.65082 11.6587 7.77648 11.014 7.13182C10.3694 6.48716 9.49502 6.125 8.58333 6.125Z",
    fill: "#C7C9C7",
    stroke: "#C7C9C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_718:24385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 23.5,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCard);
export default __webpack_public_path__ + "static/media/account_card.b1d6ae74.svg";
export { ForwardRef as ReactComponent };